import React from "react";

function Footer() {
  return (
    <footer className="main-footer">
      <strong>
        Copyright © 2026 <a href="#">PowerSoft Designs</a>.
      </strong>
       &nbsp;Todos los derechos reservados.
      <div className="float-right d-none d-sm-inline-block">
        <b>Version</b> 1.0.0
      </div>
    </footer>
  );
}

export default Footer;
